import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducer from './slices/userSlice';
import accountReducer from './slices/accountSlice';
import financeReducer from './slices/financeSlice';
import schoolAdminAccountReducer from './slices/schoolAdminAccountSlice';
import teacherAccountReducer from './slices/teacherAccountSlice';
import studentAccountReducer from './slices/studentAccountSlice';
import guardianReducer from './slices/guardianSlice';

// Separate persist configs for each reducer
const userPersistConfig = {
    key: 'user',
    storage,
    whitelist: ['details', 'account', 'authToken', 'deviceToken', 'notifications']
};

const accountPersistConfig = {
    key: 'account',
    storage,
    whitelist: ['details', 'settings', 'data', 'deviceToken']
};

const teacherAccountPersistConfig = {
    key: 'teacherAccount',
    storage,
    whitelist: ['details', 'verification', 'settings', 'courses', 'school', 'periods'] // Ensure courses is persisted
};

const studentAccountPersistConfig = {
    key: 'studentAccount',
    storage,
    whitelist: ['details', 'settings', 'subscriptions', 'school', 'quizzes', 'payment']
};

const guardianPersistConfig = {
    key: 'guardianAccount',
    storage,
    whitelist: ['details', 'students']
};

const schoolAdminPersistConfig = {
    key: 'schoolAdminAccount',
    storage,
    whitelist: ['details', 'school', 'teachers', 'settings']
};

const financePersistConfig = {
    key: 'finance',
    storage,
    whitelist: ['account', 'availableBalance', 'withdrawals']
};

// Create persisted reducers
const persistedUserReducer = persistReducer(userPersistConfig, userReducer);
const persistedAccountReducer = persistReducer(accountPersistConfig, accountReducer);
const persistedTeacherAccountReducer = persistReducer(teacherAccountPersistConfig, teacherAccountReducer);
const persistedStudentAccountReducer = persistReducer(studentAccountPersistConfig, studentAccountReducer);
const persistedFinanceReducer = persistReducer(financePersistConfig, financeReducer);
const persistedGuardianReducer = persistReducer(guardianPersistConfig, guardianReducer);
const persistedSchoolAdminAccountReducer = persistReducer(schoolAdminPersistConfig, schoolAdminAccountReducer);
export const store = configureStore({
    reducer: {
        user: persistedUserReducer,
        account: persistedAccountReducer,
        finance: persistedFinanceReducer,
        teacherAccount: persistedTeacherAccountReducer,
        studentAccount: persistedStudentAccountReducer,
        guardian: persistedGuardianReducer,
        schoolAdmin: persistedSchoolAdminAccountReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore persist-redux actions and state
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'persist/REGISTER'],
                ignoredPaths: ['register']
            },
        })
});

export const persistor = persistStore(store);